import { z } from 'zod';
import { wholeEuroCap } from './shared/euroCap.schema';

// Messages are translation keys (web namespace); the drawer resolves them with t().
const euroCap = wholeEuroCap({
  minKey: 'si_guest_declaration_validation_min_zero',
  centsKey: 'si_guest_declaration_validation_cents',
});

/**
 * The Guest's Compliance Declaration drawer. Money is in euros here (the API takes cents). A null
 * cap means "my employer sets no limit here", so the host's rule applies on that axis.
 */
export const SmartInviteDeclarationFormSchema = z.object({
  valueCapPerExperienceEuros: euroCap,
  valueCapPerYearEuros: euroCap,
  maxEventsPerPersonPerYear: z
    .number()
    .int('si_guest_declaration_validation_whole_number')
    .min(0, 'si_guest_declaration_validation_min_zero')
    .nullable(),
  forbidsAllHospitality: z.boolean(),
});

export type SmartInviteDeclarationFormValues = z.infer<
  typeof SmartInviteDeclarationFormSchema
>;
